import React from 'react';

const Referral = ({ fill = 'currentColor', ...props }) => (
  <svg
    fill={fill}
    viewBox="0 0 20.202 22.038"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(-566 -611)">
      <g transform="translate(566 611)">
        <path
          className="a"
          d="M204,621.05a5.05,5.05,0,1,1,5.05,5.05A5.05,5.05,0,0,1,204,621.05Zm5.218,3.1,2.571-2.684h.013a1.623,1.623,0,1,0-2.3-2.3l-.285.285a.23.23,0,0,1-.325,0l-.285-.285a1.623,1.623,0,1,0-2.3,2.3l2.571,2.684a.229.229,0,0,0,.331,0Z"
          transform="translate(-193.899 -616)"
        />
        <path
          className="b"
          d="M205.856,628.437a.918.918,0,0,0-1.837,0v5.05a.459.459,0,0,1-.459.459H195.3a.459.459,0,0,1-.459-.459V619.255a.919.919,0,0,1,.918-.918h5.51a.918.918,0,1,0,0-1.836h-5.51A2.755,2.755,0,0,0,193,619.255v16.07a2.755,2.755,0,0,0,2.755,2.755H203.1a2.755,2.755,0,0,0,2.755-2.755Z"
          transform="translate(-193 -616.041)"
        />
        <path
          className="b"
          d="M202.214,625.078a2.17,2.17,0,1,0-2.17,2.17A2.17,2.17,0,0,0,202.214,625.078Z"
          transform="translate(-193.398 -616.565)"
        />
        <path
          className="b"
          d="M196.563,630.954a.23.23,0,0,0,.217.3h6.308a.23.23,0,0,0,.219-.3,3.542,3.542,0,0,0-6.746,0Z"
          transform="translate(-193.29 -617.021)"
        />
      </g>
    </g>
  </svg>
);

export default Referral;
